import { css } from "@emotion/css";
import { Checkbox, Form } from "antd";

const CheckboxForm = ({ name, title, formItemProps = {} }) => {
  return (
    <Form.Item
      name={name}
      valuePropName="checked"
      getValueFromEvent={(e) => (e.target.checked ? 1 : 0)}
      {...formItemProps}
    >
      <Checkbox
        className={`${css`
          .ant-checkbox {
            align-self: start !important;
            top: 4px !important;
          }
        `}`}
      >
        {title}
      </Checkbox>
    </Form.Item>
  );
};

export default CheckboxForm;
